import { Controller } from "@hotwired/stimulus"

// Makes a whole table row behave like a link to its row-link-url-value.
// A click or Enter/Space anywhere in the row navigates, except when the
// interaction targets a genuinely interactive element (so any real links,
// buttons, or form controls nested in the row keep working).
export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (this.isInteractive(event.target)) return;
    Turbo.visit(this.urlValue);
  }

  keydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    if (this.isInteractive(event.target)) return;
    event.preventDefault();
    Turbo.visit(this.urlValue);
  }

  isInteractive(target) {
    return target.closest("a, button, input, select, textarea, label, [role='button']");
  }
}
